type ToggleProps = {  
  toggleEnabled: boolean;
  handleToggle: () => void;
}


export default function Toggle({ toggleEnabled, handleToggle }: ToggleProps) {
  return (
    <label className="flex cursor-pointer md:py-0 py-4">
    <div className="relative">
      <input
        type="checkbox"
        className="sr-only"
        checked={toggleEnabled}
        onChange={handleToggle}
      />
      <div
        className={`block ${toggleEnabled ? "bg-[#0070CD]" : "bg-white"} w-12 h-6 rounded-full border border-gray-300 flex items-center p-[2px] transition-colors duration-200 ease-in-out`}
      >
        <div 
          className={`${toggleEnabled ? "bg-white translate-x-6" : "bg-[#ADADAD] translate-x-0"} w-4 h-4 rounded-full transition-all duration-200 ease-in-out`}
        ></div>
      </div>
    </div>
  </label>
  );
}